import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'

export const recurringInvoiceEditorVariants = [
  InvoiceEditorVariant.RecurringInvoiceDraftEdit,
  InvoiceEditorVariant.RecurringInvoiceDuplicate,
  InvoiceEditorVariant.RecurringInvoiceEdit,
  InvoiceEditorVariant.RecurringInvoiceNew,
]
